<div class="col">
  <div class="card shadow-sm">
    <div class="card-body">
      <div class="row row-cols-2">
        <div class="col">
          <h4 class="mb-3">{{ 'my_orders' | translate }}</h4>
        </div>

        <div *ngIf="authorized_to_ofo" class="col d-flex justify-content-end card-filters">
          <div ngbDropdown class="d-inline-block mb-3 card-action" placement="bottom-right">
            <button type="button" class="btn btn-sm outlined-btn focus-visible" ngbDropdownToggle>
              {{ 'filter' | translate }}
              <span class="badge text-bg-primary ms-1">{{ active_filters.length }}</span>
            </button>

            <div ngbDropdownMenu class="dropdown-menu">
              <form [formGroup]="my_order_filters" class="p-3">
                <span class="mb-2 d-inline-block fw-bold">{{ 'order_recipient' | translate }}</span>

                <div class="form-check">
                  <input
                    id="myself"
                    class="me-1 mt-0 form-check-input focus-visible"
                    type="checkbox"
                    name="myself"
                    formControlName="myself"
                  />
                  <label for="myself" class="form-check-label fw-light fs-6">
                    {{ 'myself' | translate }}
                  </label>
                </div>

                <div class="form-check">
                  <input
                    id="someone_else"
                    class="me-1 mt-0 form-check-input focus-visible"
                    type="checkbox"
                    name="someone_else"
                    formControlName="someone_else"
                  />
                  <label for="someone_else" class="form-check-label fw-light fs-6">
                    {{ 'someone_else' | translate }}
                  </label>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="my_orders && my_orders_actual_count > 0; else noOrdersView" class="row">
        <div class="col">
          <form>
            <div class="mb-3 row">
              <div class="col">
                <input
                  id="table-filtering-search"
                  class="form-control focus-visible"
                  type="text"
                  placeholder="{{ 'search_placeholder' | translate }}"
                  [formControl]="search_term"
                />
              </div>
            </div>
          </form>
          <div
            class="table-responsive text-nowrap"
            [tds-data-loader]="{
              key: 'user-orders',
              size: 'lg',
              as_overlay: true
            }"
          >
            <table class="table my-orders-table">
              <thead class="text-uppercase">
                <tr>
                  <th scope="col">
                    <span
                      ngbTooltip="{{ 'store_order_id' | translate }}"
                      tooltipClass="my-orders-table-tooltip"
                    >
                      {{ 'order_id' | translate }}
                    </span>
                  </th>
                  <th scope="col">
                    <span
                      ngbTooltip="{{ 'activity_id_tooltip' | translate }}"
                      tooltipClass="my-orders-table-tooltip"
                    >
                      {{ 'activity_id' | translate }}
                    </span>
                  </th>
                  <th scope="col">
                    {{ 'related_activity_ids' | translate }}
                  </th>
                  <th scope="col">{{ 'order_type' | translate }}</th>
                  <th scope="col">{{ 'order_status' | translate }}</th>
                  <th scope="col">
                    <span
                      ngbTooltip="{{ 'carrier_tooltip' | translate }}"
                      tooltipClass="my-orders-table-tooltip"
                    >
                      {{ 'carrier' | translate }}
                    </span>
                  </th>
                  <th scope="col">{{ 'order_recipient' | translate }}</th>
                  <th scope="col">{{ 'order_placer' | translate }}</th>
                  <th scope="col">
                    <span
                      ngbTooltip="{{ 'device_model_tooltip' | translate }}"
                      tooltipClass="my-orders-table-tooltip"
                    >
                      {{ 'device_model' | translate }}
                    </span>
                  </th>
                  <th scope="col">
                    <span
                      ngbTooltip="{{ 'line_tooltip' | translate }}"
                      tooltipClass="my-orders-table-tooltip"
                    >
                      {{ 'line' | translate }}
                    </span>
                  </th>
                  <th scope="col">
                    {{ 'date_submitted' | translate }}
                    <span class="material-icons material-symbols-outlined fs-6">
                      arrow_downward
                    </span>
                  </th>
                  <th scope="col">
                    {{ 'accessories_ordered' | translate }}
                  </th>
                  <th *ngIf="cc_settings_enabled" scope="col">
                    {{ 'employee_cc_used' | translate }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let order of my_orders; index as i">
                  <td>
                    <a
                      [routerLink]="['/order-summary', order.id]"
                      class="link-body-emphasis focus-visible"
                    >
                      <ngb-highlight
                        [result]="order.id.toString()"
                        [term]="ngb_highlight_term"
                      ></ngb-highlight>
                    </a>
                  </td>
                  <td>
                    <a
                      class="link-body-emphasis focus-visible"
                      href="{{ order.source_order_url }}"
                      target="_blank"
                    >
                      <ngb-highlight
                        [result]="order.source_order_id"
                        [term]="ngb_highlight_term"
                      ></ngb-highlight>
                    </a>
                  </td>
                  <td>
                    <span
                      *ngIf="
                        order.order_type.name.includes('Bulk') && order.related_order_url;
                        else relatedIDList
                      "
                    >
                      <a
                        class="link-body-emphasis"
                        href="{{ order.related_order_url }}"
                        target="_blank"
                      >
                        {{ 'view_details' | translate }}
                      </a>
                    </span>
                    <ng-template #relatedIDList>
                      <span
                        *ngFor="
                          let related_info of order.related_order_info ?? [];
                          let is_last = last
                        "
                      >
                        <a href="{{ related_info.url }}" class="link-body-emphasis" target="_blank">
                          <ngb-highlight
                            [result]="'' + related_info.id"
                            [term]="ngb_highlight_term"
                          ></ngb-highlight>
                        </a>
                        <span *ngIf="!is_last">, </span>
                      </span>
                    </ng-template>
                  </td>
                  <td>
                    <ngb-highlight
                      [result]="order.order_type.display_name"
                      [term]="ngb_highlight_term"
                    ></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight
                      [result]="
                        order.order_status === 'N/A'
                          ? ('n_a' | translate)
                          : (order.order_status | titlecase)
                      "
                      [term]="ngb_highlight_term"
                    ></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight
                      [result]="order.carrier.name"
                      [term]="ngb_highlight_term"
                    ></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight
                      [result]="
                        order.order_recipient.first_name + ' ' + order.order_recipient.last_name
                      "
                      [term]="ngb_highlight_term"
                    ></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight
                      [result]="order.order_placer.first_name + ' ' + order.order_placer.last_name"
                      [term]="ngb_highlight_term"
                    ></ngb-highlight>
                  </td>
                  <td>
                    <span
                      class="d-block text-truncate limit-width"
                      title="{{ order.device?.name }}"
                    >
                      <ngb-highlight
                        [result]="order.device?.name"
                        [term]="ngb_highlight_term"
                      ></ngb-highlight>
                    </span>
                  </td>
                  <td>
                    <ngb-highlight
                      [result]="order.line.number"
                      [term]="ngb_highlight_term"
                    ></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight
                      [result]="order.date_submitted | date : 'medium'"
                      [term]="ngb_highlight_term"
                    >
                    </ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight
                      [result]="
                        order.accessories_ordered
                          ? ('yes' | translate | uppercase)
                          : ('no' | translate | uppercase)
                      "
                      [term]="ngb_highlight_term.toString().toUpperCase()"
                    >
                    </ngb-highlight>
                  </td>
                  <td *ngIf="cc_settings_enabled">
                    <ngb-highlight
                      [result]="
                        order.is_credit_card_used
                          ? ('yes' | translate | uppercase)
                          : ('no' | translate | uppercase)
                      "
                      [term]="ngb_highlight_term.toString().toUpperCase()"
                    >
                    </ngb-highlight>
                  </td>
                </tr>
                <tr *ngIf="my_orders_total_count === 0">
                  <td colspan="12" class="text-start">
                    {{ 'no_results' | translate }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Large and up screens -->
          <div class="row d-none d-lg-flex justify-content-between align-items-center mt-3">
            <div class="col-auto">
              <select
                class="form-select w-auto focus-visible cursor-pointer"
                [(ngModel)]="page_size"
                (ngModelChange)="getUserOrders(search_term.value)"
              >
                <option *ngFor="let option of page_size_options" [ngValue]="option.value">
                  {{ option.name }}
                </option>
              </select>
            </div>
            <div class="col-auto">
              <span>
                {{ this.calculateTableIndexLabel() }}
              </span>
            </div>
            <div class="col-auto">
              <ngb-pagination
                class="float-sm-end order-table-pagination"
                [(page)]="current_page"
                [boundaryLinks]="true"
                [collectionSize]="my_orders_total_count"
                [ellipses]="false"
                [maxSize]="5"
                [pageSize]="page_size"
                [rotate]="true"
                (pageChange)="getUserOrders(search_term.value)"
              >
              </ngb-pagination>
            </div>
          </div>
          <!-- xs - md screens -->
          <div class="row d-flex d-lg-none justify-content-between mt-3 mt-xl-0">
            <div class="col-12 col-sm-6 d-flex d-sm-block justify-content-center">
              <select
                class="form-select w-auto cursor-pointer"
                [(ngModel)]="page_size"
                (ngModelChange)="getUserOrders(search_term.value)"
              >
                <option *ngFor="let option of page_size_options" [ngValue]="option.value">
                  {{ option.name }}
                </option>
              </select>
            </div>
            <div class="col-12 col-sm-6 d-flex flex-column align-items-center align-items-sm-end">
              <span class="my-3 mt-sm-2 mb-sm-3">
                {{ this.calculateTableIndexLabel() }}
              </span>
              <ngb-pagination
                class="float-sm-end order-table-pagination"
                [(page)]="current_page"
                [boundaryLinks]="true"
                [collectionSize]="my_orders_total_count"
                [ellipses]="false"
                [maxSize]="5"
                [pageSize]="page_size"
                [rotate]="true"
                (pageChange)="getUserOrders(search_term.value)"
              >
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
      <ng-template #noOrdersView>
        <div class="row row-col-1">
          <div class="col my-5 text-center" [tds-data-loader]="{ key: 'user-orders', size: 'lg' }">
            <h2 class="text-secondary">
              {{ 'no_results_available' | translate }}
            </h2>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
